import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
} from "@mui/material";
import Images from "../../assets";
import { coordinatorSwitchStage, newApplicationApproval, result, revertDecision } from "../../services";
import { counsellorstages, processingStages } from "../../assets/enums";

export const Stage = (props: { stage: string; id: string; status: string,setStatus:any }) => {
  const role = localStorage.getItem("role");
  const listRef = useRef<HTMLUListElement | null>(null);
  const [selectedStage, setSelectedStage] = useState<string>(props.stage);
  const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});
  const [expandedStage, setExpandedStage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [isListOpen, setIsListOpen] = useState<boolean>(false);
  const [stages, setStages] = useState<string[]>([]);

  useEffect(() => {
    if (role === "counsellor") {
      setStages(counsellorstages);
    } else if (role === "processCoordinator") {
      setStages(processingStages);
    }
    // eslint-disable-next-line
  }, []);

  const handleStageClick = (stage: string) => {
    setExpandedStage(stage === expandedStage ? null : stage);
  };

  const handleInputChange = (event: any, stage: string) => {
    setInputValues({ ...inputValues, [stage]: event.target.value });
  };

  const handleSubmit = async (stage: string) => {
    setLoading(true);
    let action;
    if (stage === "Counsellor Approved") {
      action = "approve";
    } else if (stage === "Counsellor Disapproved") {
      action = "disapprove";
    }
    try {
      const response = await newApplicationApproval({
        applicationId: props.id,
        action: action,
        justification: inputValues[stage],
      });
      if (response) {
        setSelectedStage(stage);
      }
      setLoading(false);
      setIsListOpen(false);
      setExpandedStage(null);
      setInputValues({});
    } catch (err) {
      setLoading(false);
    }
  };

  const handleSubmit1 = async (stage: string) => {
    setLoading(true);
    try {
      const response = await coordinatorSwitchStage({
        status: props?.status,
        applicationId: props.id,
        stage: stage,
        note: inputValues[stage],
      });
      if (response) {
        setSelectedStage(stage);
      }
      setLoading(false);
      setIsListOpen(false);
      setExpandedStage(null);
      setInputValues({});
    } catch (err) {
      setLoading(false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (listRef.current && !listRef.current.contains(event.target as Node)) {
      setIsListOpen(false);
      setExpandedStage(null);
      setInputValues({});
    }
  };

  const handleAcceptStatus = async (item:any) => {
    setLoading(true);

    const response = await result(
      {
        applicationId: props.id,
        result: item,
      }
    );
    if (response) {
      setSelectedStage(response?.data?.data?.stage);
      props.setStatus(response?.data?.data?.status)
    } else {
      
    }
    setLoading(false);

  };

  // // revert
  const handleRevertDecision = async () => {
    setLoading(true);

    const response = await revertDecision(
      {
        applicationId: props.id,
      }
    );
    if (response) {
      props.setStatus(response?.data?.data?.status);
      setSelectedStage(response?.data?.data?.stage);
      setLoading(false);
    } else{
      setLoading(false);
    }
    

  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
        <Button
        onClick={() => setIsListOpen(!isListOpen)}
        sx={{
          color: "#000",
          backgroundColor:
            props.stage === "Counsellor Approved"
              ? "#FBE3C8"
              : "#F0F1F9 !important",
          textTransform: "none",
        }}
      >
        {selectedStage}
      </Button>

        {props.status === "Processing" && selectedStage === "Conditional Acceptance" ? (
          <Box sx={{ display: "flex" }}>
            <Button
              sx={{ m: 2 ,  borderRadius: "10px",
              textTransform: "capitalize",
              fontSize: "0.9rem",
              background: "#316539",
              color: "#fff",
              "&:hover": {
                background: "#316539",
              },}}
              onClick={() => handleAcceptStatus("Accepted")}
            >
              Accept
            </Button>
            <Button
              sx={[ { m: 2,  borderRadius: "10px",
              textTransform: "capitalize",
              fontSize: "0.9rem",
              background: "red",
              color: "#fff",
              "&:hover": {
                background: "red",
              }, }]}
              onClick={() => handleAcceptStatus("Rejected")}
            >
              Reject
            </Button>
          </Box>
        ):
      ""
      }
      {(props.status === "Accepted" && selectedStage === "Result Received") ||
                props.status === "Rejected" ? (
                <Box sx={{ display: "flex" }}>
                  <Button
                     sx={{ m: 2 ,  borderRadius: "10px",
                     textTransform: "capitalize",
                     fontSize: "0.9rem",
                     background: "#316539",
                     color: "#fff",
                     "&:hover": {
                       background: "#316539",
                     },}}
                    onClick={() => handleRevertDecision()}
                  >
                    Revert
                  </Button>
                </Box>
              ) : null}
      
      <Collapse in={isListOpen} timeout="auto" unmountOnExit>
        <Paper
          elevation={1}
          sx={{
            mt: 2,
            position: "absolute",
            zIndex: 1,
            top: 0,
            boxShadow: 2,
            width: "300px",
          }}
        >
          <List ref={listRef} sx={{ height: "auto",maxHeight:"300px", overflowY: "scroll" }}>
            {stages.map((stage) => (
              <div key={stage}>
                <ListItem
                  button
                  onClick={() => handleStageClick(stage)}
                  disabled={stage === selectedStage}
                  sx={{ py: 0 }}
                >
                  <ListItemText primary={stage} />
                </ListItem>
                <Collapse
                  in={expandedStage === stage}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box sx={{ pl: 4, pr: 4, pb: 2 }}>
                    <TextField
                      size="small"
                      fullWidth
                      value={inputValues[stage] || ""}
                      onChange={(event: any) => handleInputChange(event, stage)}
                      placeholder={`Add note`}
                      sx={{ my: 1 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (role === "counsellor") {
                          handleSubmit(stage);
                        } else {
                          handleSubmit1(stage);
                        }
                      }}
                      sx={{
                        backgroundColor: "#3B3F76",
                        color: "#fff",
                        fontWeight: "500",
                        fontSize: "13px",
                        width: "80px",
                        textTransform: "none",
                        borderRadius: "10px",
                        "&:hover": {
                          backgroundColor: "#3B3F76",
                          color: "#fff",
                        },
                      }}
                    >
                      {loading ? (
                        <img
                          src={Images.standardLoader}
                          alt="load"
                          style={{
                            width: "20px",
                            height: "20px",
                            padding: "5px",
                          }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </Box>
                </Collapse>
              </div>
            ))}
          </List>
        </Paper>
      </Collapse>
    </Box>
  );
};
